<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const props = withDefaults(
        defineProps<{
            name?: string;
            label?: string;
        }>(),
        {
            name: "rontgen",
            label: "Röntgen",
        }
    );

    const fetchRontgen = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/rontgen/fetchRontgen", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/rontgen/rontgenSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            console.error("Kunde inte hämta röntgen:", error);
            flashWarning("Kunde inte hämta röntgen");
        }
    };
</script>

<template>
    <KAutocomplete
        :name="name"
        :label="label"
        v-bind="$attrs"
        :options="fetchRontgen"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
